"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6 10.756C6 7.25 8.666 4 12.38 4c3.633 0 6.379 3.244 6.379 6.756v.016c-.055 1.77-.894 3.65-1.948 5.23-1.055 1.583-2.377 2.939-3.485 3.644a1.76 1.76 0 0 1-1.891 0c-1.118-.706-2.44-2.043-3.495-3.618-1.053-1.573-1.885-3.452-1.94-5.256zm8.88-.748a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
}), 'MapPinFilled');
//# sourceMappingURL=index.js.map